import React, { Component } from 'react';

export default class FuelEvents extends Component {
  render() {
    return <div>События топлива</div>;
  }
}
